<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->

<div class="wrapper">
  @if (this.isInitialLoading) {
    <div class="center-content">
      <mat-spinner></mat-spinner>
    </div>
  } @else if (this.showErrorMessage) {
    <div class="center-content">
      @if (this.noStandingsFound) {
        <div class="no-matches-container">
          <h1>Its empty here</h1>
          <h2>It seems like there are no standings for the knockout phase yet.</h2>
        </div>
      } @else {
        <h1>There was an error loading the data.</h1>
      }
    </div>
  } @else {
    <div class="tree-container">
      @if (this.tree !== undefined) {
        <app-knockout-phase-tree-node
          [node]="this.tree"
          [template]="nodeTemplate"
        ></app-knockout-phase-tree-node>
      }
    </div>
  }

  <ng-template
    #nodeTemplate
    let-matchId="id"
    let-team="team"
    let-table="table"
    let-preceedingStandings="preceedingStandings"
    let-parentMatchHasTableAssigned="parentMatchHasTableAssigned"
  >
    <div class="qualification-match-container">
      @if (table !== null && table !== undefined) {
        <div class="table">{{ table.name }}</div>
      }
      <mat-card
        appearance="outlined"
        [class.beginner-team-node]="isBeginnerNode(preceedingStandings)"
        [class.ko-match-node]="!isBeginnerNode(preceedingStandings)"
        [class.team-final-winner]="this.teamHasPreviousWonRound(matchId) === 'final-winner'"
        [class.team-winner]="this.teamHasPreviousWonRound(matchId) === 'winner'"
        [class.team-loser]="this.teamHasPreviousWonRound(matchId) === 'loser'"
      >
        <mat-card-content style="padding: var(--spacing1)">
          {{ team?.name ?? '&nbsp;' }}
          @if (parentMatchHasTableAssigned && !teamHasPickedUpDrinksForMatch(matchId, team)) {
            <span class="get-your-drinks-info display-right">Get your drinks!</span>
          }
        </mat-card-content>
      </mat-card>
    </div>
  </ng-template>
</div>
